import { queryOptions } from '@tanstack/react-query'

import { apiClient } from '@/features/api'
import { createApiQuery } from '@/features/api/helper'

import type { ITransaction } from './type'

/* ---------------------------------- KEYS ---------------------------------- */
export const SALES_KEY = {
	TRANSACTION_LIST: '/sales/transaction/list',

	REPORT_CHART: '/sales/report/chart',
}

/* ---------------------------- SALES TRANSACTION --------------------------- */

const salesTransactionList = createApiQuery<
	{ oId: string; date: [string, string] | string },
	{ transactions: ITransaction[] }
>(SALES_KEY.TRANSACTION_LIST)

/* ------------------------------ SALES:REPORT ------------------------------ */

// Report chart
type ISalesReportChartParams = {
	outletId: string
	from: string
	to: string
}

export type ISalesReportChartItem = {
	_id: string
	net: number
	gross: number
	cogs: number
	trxTotal: number
}

type ISalesReportChartResponse = TResSuccess<{
	result: ISalesReportChartItem[]
}>

async function salesReportChartApi(params: ISalesReportChartParams) {
	const res = await apiClient<ISalesReportChartResponse>(
		SALES_KEY.REPORT_CHART,
		{ params }
	)

	return res.data.data
}

export function salesReportChartQuery(params: ISalesReportChartParams) {
	return queryOptions({
		queryKey: [SALES_KEY.REPORT_CHART, params],
		queryFn: () => salesReportChartApi(params),
	})
}

/* --------------------------------- EXPORT --------------------------------- */

export { salesTransactionList }
